import React from 'react'
import { START_LOADING, STOP_LOADING } from './LoaderTypes'
import { Store } from '../Store.dt'

const InitialState = {
  isLoading: false,
  message: '',
  pageName: ''
}

function LoaderReducer(state = InitialState, action: Store) {
  switch (action.type) {
    case START_LOADING:
      return { ...action.payload }
    case STOP_LOADING:
      return { ...action.payload }
    default: return state
  }
}

export default LoaderReducer